var ezdia;
(function (ezdia) {
    var self;
    var pageParams = {};
    var actiontype = null;
    var accountKey = null;
    var template = null;
    var rowId = null;
    var accBtnTemplate = null;
    var accCount = 0;
    var preAccWrapId = 'ez-site-account-wrapper-';
    var preFieldWrapId = 'ez-site-field-maps-wrapper-';
    var isSameMapAcc = false;
    var aemFieldList = {};
    var validObj = {};
    var fieldMapArray = [];
    var createHiddenSiteType = function (siteVal) {
        var value = getColDataString('', siteVal) || '';
        var content = '';
        // eslint-disable-next-line consistent-return
        $.each(pageParams.siteTypes, function (key, obj) {
            if (obj.label === value) {
                value = key;
                return false;
            }
        });
        content = $('<input>', {
            type: 'hidden',
            id: 'site_type',
            name: 'site_type',
            value: value || ''
        });
        content = content.prop('outerHTML');
        $('#ez-form-create_site-site_type-row')
            .find('div[data-row="input"]')
            .append(content);
    };
    var setSiteName = function (siteName) {
        var elem = $('[name=site_name]');
        var content = '';
        var value = getColDataString('', siteName) || '';
        if (!elem.length) {
            content = $('<input>', {
                type: 'hidden',
                name: 'site_name',
                value: value || ''
            });
            self.cache.editfrm.append(content);
        }
    };
    var setSiteType = function (selected, siteVal) {
        var selectedVal = '';
        var elem = $('[name=site_type]');
        if (!elem.length) {
            createHiddenSiteType(siteVal);
            if (siteVal === 'googleAnalytics' || siteVal === 'ezAnalytics') {
                $('#ez-form-create_site-tool_name-row').show();
                $('#ez-form-create_site-site_url-row').show();
            }
            return;
        }
        if (selected) {
            selectedVal = elem.val();
        }
        elem.empty().append($('<option>'));
        $.each(pageParams.siteTypes, function (key, value) {
            var opt = $('<option>', {
                value: key,
                text: value.label
            });
            if (value.label === selectedVal) {
                opt.attr('selected', 'selected');
            }
            elem.append(opt);
        });
    };
    // eslint-disable-next-line consistent-return
    var siteTypeChange = function () {
        self.cache.siteAccWrap.empty();
        if (!self.cache.siteType.val()) {
            $('#ez-test-site-config').hide();
            $('#ez-test-semrush-config').hide();
            $('#ez-google-authorize').hide();
            $('#site_acc_mapping_checkbox-main').hide();
            $('#site_url-main').hide();
            return false;
        }
        $('#site_acc_mapping_checkbox-main').show();
        $('[name="site_acc_mapping_checkbox"]').attr('checked', 'false');
        accCount = 0;
        isSameMapAcc = false;
        setAdditionalFields();
        if (self.cache.siteType.val() === 'semrush') {
            $('#ez-test-semrush-config').show();
            $('#ez-test-site-config').hide();
            $('#ez-google-authorize').hide();
            $('#site_url-main').show();
            setAccounts.call(self);
            if ($('input[name=site_url]').val() === '-') {
                $('input[name=site_url]').val('');
            }
        }
        else if (self.cache.siteType.val() === 'wordpress' ||
            self.cache.siteType.val() === 'aem') {
            $('#ez-test-site-config').show();
            $('#ez-google-authorize').hide();
            $('#site_url-main').show();
            setAccounts.call(self);
            if ($('input[name=site_url]').val() === '-') {
                $('input[name=site_url]').val('');
            }
        }
        else if (self.cache.siteType.val() === 'eBay' ||
            self.cache.siteType.val() === 'walmart-csp' ||
            self.cache.siteType.val() === 'walmart-rm') {
            $('#ez-test-site-config').hide();
            $('#ez-test-semrush-config').hide();
            $('#ez-google-authorize').hide();
            $('#site_acc_mapping_checkbox-main').hide();
            $('#site_url-main').hide();
            setAccounts.call(self);
        }
        else {
            $('#ez-test-site-config').hide();
            $('#ez-test-semrush-config').hide();
            $('#ez-google-authorize').hide();
            $('#site_acc_mapping_checkbox-main').hide();
            $('#site_url-main').hide();
        }
        $('#template_name').change(function () {
            testConfigClick();
        });
    };
    var setAdditionalFields = function (rowData) {
        var siteVal = '';
        if (rowData) {
            siteVal = $('[name="site_type"]').val();
        }
        else {
            siteVal = self.cache.siteType.val();
        }
        var data = "&site_type=" + siteVal;
        $.ajax({
            type: 'POST',
            url: 'GetAdditionalSiteFields.htm',
            data: data,
            dataType: 'json',
            async: false,
            success: function (res) {
                additionalFields(res, rowData);
            }
        });
    };
    var additionalFields = function (addColModel, rowData) {
        var content = '';
        var data;
        template = $.ezdia.template.get('base-form-row');
        validate(true);
        if (addColModel) {
            $.ezdia.widgets.load(actiontype);
            if (rowData) {
                var siteResp = pageParams.jqGridRowsData.data;
                rowId = rowData ? getColDataString('', rowData.id) : null;
                data = siteResp.filter(function (_a) {
                    var id = _a.id;
                    return id === +rowId;
                });
            }
            else {
                data = [];
            }
            $.each(addColModel, function (i, column) {
                var value = data.length ? data[0][column.name] : '';
                var inputs = '';
                var obj = {
                    column: column,
                    value: value
                };
                column.edittype = column.type;
                column.editable = true;
                column.config = $.ezdia.getFieldsConfig(column);
                inputs = $.ezdia.inputs.create(obj, actiontype);
                content += additionalFieldsMarkup(inputs, column);
                if (column.validate_rules || column.required) {
                    validObj[column.name] = column.validate_rules || {
                        required: column.required
                    };
                }
                $.ezdia.widgets.init(obj);
            });
        }
        appendContent(content);
        validate();
        if (content) {
            $.ezdia.widgets.create(actiontype);
        }
    };
    var validate = function (remove) {
        $.each(validObj, function (key, obj) {
            var elem = $("[name=\"" + key + "\"]");
            var id = elem.attr('id');
            if (remove) {
                elem.rules('remove');
                $("#" + id + "-error").remove();
            }
            else {
                elem.rules('add', obj);
            }
        });
        if (remove) {
            validObj = {};
        }
    };
    var wrapper = function (id) {
        var wrap = $("#" + id);
        if (!wrap.length) {
            var html = $('<div>', {
                id: id
            });
            $('[name="site_status"]').closest('[data-row="row"]').after(html);
            wrap = $("#" + id);
        }
        return wrap;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var getValue = function (siteResp, column) {
        var value = '';
        $.each(siteResp, function (i, obj) {
            if (obj.id === rowId) {
                $.each(obj, function (key, mval) {
                    if (key === column.name) {
                        value = mval;
                    }
                });
            }
        });
        return value;
    };
    var appendContent = function (content) {
        var container = wrapper('createNewSite-additional-fields');
        container.html(content);
    };
    var additionalFieldsMarkup = function (inputs, column) {
        var content = $.ezdia.inputs.rowMarkup(template, column, inputs);
        if (column.edittype === 'hidden') {
            content = inputs;
        }
        else {
            content = content.prop('outerHTML');
        }
        return content;
    };
    function removeFields() {
        $('[name=site_account_name]').closest('[data-row="row"]').remove();
        $('[name=site_field_map]').closest('[data-row="row"]').remove();
        $('[name=site_acc_mapping_checkbox]')
            .closest('[data-row="row"]')
            .hide()
            .after('<div id="ez-site-accounts"></div>');
        this.cache.siteAccWrap = $('#ez-site-accounts');
        this.cache.siteAccWrap
            .on('click', '[data-site-account="add"]', function () {
            setAccounts.call(self);
        })
            .on('click', '[data-site-account="remove"]', function click() {
            $(this).closest('[data-site-account="wrapper"]').remove();
            var len = $('[data-site-account="remove"]').length;
            if (!len) {
                setAccounts.call(self);
            }
        });
    }
    function accountWrapper() {
        var id = preAccWrapId + accCount;
        var div = $('<div>', {
            id: id,
            'data-site-account': 'wrapper',
            class: 'ez-site-account-wrapper'
        });
        this.cache.siteAccWrap.append(div);
        return $("#" + id);
    }
    function setAccounts() {
        var wrap = accountWrapper.call(this);
        var id = "site_account_name_" + accCount;
        var siteAccount = {
            name: "site_account_name_" + accCount,
            label: 'Project Type*',
            edittype: 'singlechoice',
            editable: true,
            id: id,
            config: {
                options: pageParams.allAccounts,
                cssClass: 'display-inline'
            }
        };
        var opt = $.ezdia.inputs.getMarkup({
            column: siteAccount
        }, actiontype);
        var btn = accBtnTemplate({
            count: accCount
        });
        opt.find("#" + id).attr('data-count', accCount).after(btn);
        var map = getFieldMap.call(this, accCount);
        wrap.append(opt).append(map);
        $("#" + id).on('change', onProjectChange);
        accCount += 1;
    }
    var getFieldMap = function (count, value) {
        var siteName = $('[name=site_type]').val();
        var siteObj = pageParams.siteTypes[siteName];
        var content = '';
        fieldMapArray = [];
        if (siteObj && siteObj.fields) {
            var fields = ezdia.util.jsonParse(siteObj.fields);
            var fldOptions_1 = pageParams.availableFields[value];
            var id = preFieldWrapId + count;
            var mapWrap_1 = $('<div>', {
                id: id
            });
            $.each(fields.remote_fields || {}, function (i, col) {
                var column = {
                    name: col.name + "_" + count,
                    label: col.label,
                    edittype: 'singlechoice',
                    editable: true,
                    id: col.name + count
                };
                var field = $.ezdia.inputs.getMarkup({
                    column: column
                }, actiontype);
                if (fldOptions_1) {
                    field
                        .find("#" + col.name + count)
                        .append(fieldMapOptValue(fldOptions_1, col.suggested_map));
                }
                if (isSameMapAcc) {
                    mapWrap_1.hide();
                }
                column.config = {
                    sorting: true
                };
                fieldMapArray.push(column);
                content += field.prop('outerHTML');
            });
            content = mapWrap_1.append(content);
        }
        return content;
    };
    function fieldMapOptValue(obj, value) {
        var content = '';
        $.each(obj, function (i, mval) {
            var opt = $('<option>', {
                value: mval.name,
                text: mval.label
            });
            if (mval.name === value) {
                opt.attr('selected', 'selected');
            }
            content += opt.prop('outerHTML');
        });
        return content;
    }
    var onProjectChange = function (e) {
        var elem = $(e.currentTarget);
        var count = elem.data('count');
        var value = elem.val();
        var content = getFieldMap(count, value);
        $("#" + preFieldWrapId + count).empty().append(content);
        $.ezdia.singlechoice.create(fieldMapArray);
    };
    function siteCheckBoxClicked() {
        var checkbox = $(this);
        if (checkbox.prop('checked')) {
            hideFieldMap();
            isSameMapAcc = true;
        }
        else {
            showFieldMap();
            isSameMapAcc = false;
        }
    }
    var showFieldMap = function () {
        $('#field_acc_name_0').show();
        for (var counter = 1; counter <= accCount; counter++) {
            $("#" + preFieldWrapId + counter).show();
        }
    };
    var hideFieldMap = function () {
        $('#field_acc_name_0').hide();
        for (var counter = 1; counter <= accCount; counter++) {
            $("#" + preFieldWrapId + counter).hide();
        }
    };
    var createEditSiteFieldMap = function (siteData, fieldMapObj) {
        var fieldMap = $.parseJSON(siteData.rowFieldMap);
        if (fieldMapObj.aemComp) {
            $.each(fieldMapObj.aemComp, function (key, value) {
                fieldMap.remote_fields.push({
                    label: value,
                    name: key,
                    suggested_map: ''
                });
            });
        }
        $.each(fieldMapObj.toolName, function (index, value) {
            fieldMapArray = [];
            accCount = index;
            var wrap = accountWrapper.call(self);
            var accName = pageParams.allAccounts[value];
            var id = "site_account_name_" + index;
            var accfldObj = {
                name: "site_account_name_" + index,
                label: 'Project Type',
                edittype: 'text',
                editable: true,
                readonly: true,
                id: id,
                config: {
                    cssClass: 'input-xlarge input-inline'
                }
            };
            var opt = $.ezdia.inputs.getMarkup({
                column: accfldObj,
                value: accName
            }, actiontype);
            var btn = accBtnTemplate({
                count: index
            });
            opt.find("#" + id).attr('data-count', index).after(btn);
            var map = getFieldMapEdit(index, fieldMapObj, fieldMap, value);
            wrap.append(opt).append(map);
            $.ezdia.singlechoice.create(fieldMapArray);
        });
        accCount += 1;
    };
    var getFieldMapEdit = function (count, fldMapObj, fldObj, value) {
        var fieldMapObj = fldMapObj.fieldMap[count];
        var id = preFieldWrapId + count;
        var mapWrap = $('<div>', {
            id: id
        });
        var content = '';
        fieldMapObj = $.ezdia.getJsonObject(fieldMapObj);
        $.each(fieldMapObj, function (key, mval) {
            var fldOptions = pageParams.availableFields[value];
            $.each(fldObj.remote_fields, function (i, col) {
                if (key === col.name) {
                    var column = {
                        name: col.name + "_" + count,
                        label: col.label,
                        edittype: 'singlechoice',
                        editable: true,
                        id: col.name + count
                    };
                    var field = $.ezdia.inputs.getMarkup({
                        column: column
                    }, actiontype);
                    field
                        .find("#" + col.name + count)
                        .append(fieldMapOptValue(fldOptions, mval));
                    content += field.prop('outerHTML');
                    column.config = {
                        sorting: true
                    };
                    fieldMapArray.push(column);
                }
            });
        });
        return mapWrap.append(content);
    };
    var getCredentials = function (sites) {
        var result = '';
        $.ajax({
            type: 'POST',
            url: 'GetSiteCredentials.htm?',
            dataType: 'json',
            async: false,
            data: "site_names=" + sites,
            success: function (response) {
                result = response;
            },
            // tslint:disable-next-line:no-empty
            error: function () {
                //
            }
        });
        return result;
    };
    var testConfig = function (old) {
        var wrapperId = 'ez-test-integration-wrapper';
        var siteName = $('[name=site_name]').val();
        var sites = null;
        var wrap = $("#" + wrapperId);
        var content = '';
        var context = [];
        var tcTemplate = $.ezdia.template.get('integration-test-config');
        var btnObj = [
            {
                text: 'Cancel',
                class: 'btn-link',
                click: function () {
                    $(this).dialog('close');
                }
            }
        ];
        if (!wrap.length) {
            var div = $('<div>', { id: wrapperId });
            $('body').append(div);
            wrap = $("#" + wrapperId);
        }
        if (siteName) {
            sites = [siteName];
        }
        else {
            siteName = $('[name=sys_publish_sites]').val();
            sites = siteName ? siteName.split('##') : null;
        }
        if (sites) {
            var credentials_1 = getCredentials(sites);
            $.each(sites, function (i, val) {
                if (!val) {
                    return;
                }
                var obj = {
                    id: $.ezdia.sanitizer.specialChar(val),
                    label: val,
                    userName: ' '
                };
                var usrObj = credentials_1[val];
                $.extend(obj, usrObj);
                context.push(obj);
            });
            content = tcTemplate(context);
            btnObj.push({
                text: 'Test Configuration',
                class: 'btn-primary',
                click: function () {
                    if (old === true) {
                        publishData(sites);
                    }
                    else {
                        publishData2(sites);
                    }
                    $(this).dialog('close');
                }
            });
        }
        else {
            content = 'Please Select Site.';
        }
        wrap
            .html(content)
            .dialog({
            modal: true,
            title: 'Test Config',
            width: '500',
            minHeight: 0,
            buttons: btnObj
        })
            .css('maxHeight', window.innerHeight - 100 || 500);
        wrap.find('[id^=ez-show-passwd_]').on('click', togglePassword);
    };
    function togglePassword() {
        var id = this.id.substring(8);
        var type = 'password';
        if (this.checked) {
            type = 'text';
        }
        $("#" + id).attr('type', type);
    }
    var testSemrushConfig = function () {
        var data = $('#ez-edit-store-form').serialize();
        data += "&isSameMapAcc=" + isSameMapAcc;
        $.ajax({
            type: 'POST',
            url: 'TestSiteConnection.htm',
            data: data,
            dataType: 'json',
            success: function (response) {
                var editfrm = self.cache.editfrm;
                if (response.success) {
                    ezdia.util.showSuccessError({
                        message: response.msg,
                        autohide: false
                    });
                    editfrm.localStorage('discard');
                }
                else {
                    ezdia.util.showSuccessError({
                        message: response.msg,
                        error: true,
                        autohide: false
                    });
                }
            },
            error: function (response) {
                var obj = {
                    response: response,
                    success: false,
                    url: ''
                };
                successErrorDialog(obj);
            }
        });
    };
    var publishData2 = function (sites) {
        var data = null;
        if (!sites) {
            return;
        }
        if (sites.length === 1) {
            var postid = $.ezdia.sanitizer.specialChar(sites[0]);
            data = $('#createNewSite').serialize();
            if (!data) {
                data = $('#ez-edit-store-form').serialize();
            }
            publishAjaxReq(data, postid);
        }
        else {
            $.each(sites, function (i, val) {
                if (val) {
                    var postid = $.ezdia.sanitizer.specialChar(val);
                    data = $('#bulkEditFrm').serialize();
                    publishAjaxReq(data, postid);
                }
            });
        }
    };
    var publishAjaxReq = function (reqdata, postid) {
        var data = reqdata;
        data += "&userName=" + encodeURIComponent($("#user_name_" + postid).val());
        data += "&passwd=" + encodeURIComponent($("#passwd_" + postid).val());
        data += "&site_type=" + $('[name=site_type]').val();
        data += "&site_url=" + $('[name=site_url]').val();
        $.ajax({
            type: 'POST',
            url: 'TestSiteConnection.htm',
            data: data,
            dataType: 'json',
            cache: false,
            success: function (response) {
                testSiteConnection = true;
                if (response.aem_components) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    aemFieldList = response.aem_components;
                }
                var obj = {
                    response: response.msg,
                    success: response.success,
                    url: ''
                };
                successErrorDialog(obj);
            },
            error: function (response) {
                var obj = {
                    response: response,
                    success: false,
                    url: ''
                };
                successErrorDialog(obj);
            }
        });
    };
    function updateData() {
        var btn = $(this);
        if (!self.cache.editfrm.valid()) {
            return false;
        }
        btn.button('loading');
        var sites = $('[name=site_name]').val();
        var siteStr = $.ezdia.sanitizer.specialChar(sites);
        var siteUserName = $("#user_name_" + siteStr).val();
        var sitePassword = $("#passwd_" + siteStr).val();
        var data = $('#ez-edit-store-form').serialize();
        data += "&userName=" + encodeURIComponent(siteUserName);
        data += "&passwd=" + encodeURIComponent(sitePassword);
        data += "&isConnectionTested=" + testSiteConnection;
        data += "&accCount=" + accCount;
        data += "&isSameMapAcc=" + isSameMapAcc;
        $.ajax({
            type: 'POST',
            url: 'EditSite.htm',
            data: data,
            dataType: 'json',
            success: function (response) {
                var editfrm = self.cache.editfrm;
                if (response.success) {
                    ezdia.util.showSuccessError({
                        message: response.msg
                    });
                    editfrm.localStorage('discard');
                    editfrm.hide();
                    $('#grid').trigger('reloadGrid');
                }
                else {
                    ezdia.util.showSuccessError({
                        message: response.msg,
                        error: true,
                        autohide: false
                    });
                }
            },
            error: function (response) {
                var obj = {
                    response: response,
                    success: false,
                    url: ''
                };
                successErrorDialog(obj);
            }
        }).always(function () {
            btn.button('reset');
        });
        return false;
    }
    var confirmDeactivate = function () {
        var wrap = $.ezdia.getWrapper(preAccWrapId + "confirm-deactivate");
        wrap.html('Are you sure you want to Deactivate this account?').dialog({
            modal: true,
            title: 'Deactivate account?',
            width: 400,
            height: 200,
            buttons: [
                {
                    text: 'Cancel',
                    class: 'btn-link',
                    click: function () {
                        $(this).dialog('close');
                    }
                },
                {
                    text: 'Deactivate',
                    class: 'btn-default',
                    click: function (e) {
                        var btn = $(e.currentTarget);
                        deactivateSite($(this), btn);
                    }
                }
            ]
        });
    };
    var deactivateSite = function (panel, btn) {
        btn.button('loading');
        $.ajax({
            type: 'POST',
            url: 'DeactivateSite.htm',
            data: $('#ez-edit-store-form').serialize(),
            dataType: 'json',
            success: function (response) {
                var editfrm = self.cache.editfrm;
                if (response.success) {
                    ezdia.util.showSuccessError({
                        message: response.msg
                    });
                    editfrm.localStorage('discard');
                    editfrm.hide();
                    panel.dialog('close');
                }
                else {
                    ezdia.util.showSuccessError({
                        message: response.msg,
                        error: true,
                        autohide: false
                    });
                }
            },
            error: function (response) {
                $('#message').html(response);
            }
        }).always(function () {
            btn.button('reset');
            $('#grid').trigger('reloadGrid');
        });
    };
    var performGAAuthorization = function () {
        var data;
        if ($('#site_name').val() === undefined) {
            data = "site_name=" + $('[name=site_name]').val();
        }
        else {
            data = "site_name=" + $('#site_name').val();
        }
        $.ajax({
            type: 'POST',
            url: 'GetGAURLS.htm',
            data: data,
            dataType: 'json',
            async: false,
            success: function (response) {
                window.location.href = response.oauthUrl;
            }
        });
    };
    function saveData() {
        var frm = $('#createNewSite');
        if (self.cache.siteType.val() !== 'wordpress' &&
            self.cache.siteType.val() !== 'semrush' &&
            self.cache.siteType.val() !== 'aem' &&
            self.cache.siteType.val() !== 'googleAnalytics' &&
            self.cache.siteType.val() !== 'ezAnalytics') {
            $('input[name=site_url]').val('-');
        }
        if (!frm.valid()) {
            return;
        }
        var sites = $('#site_name').val();
        var siteStr = $.ezdia.sanitizer.specialChar(sites);
        var siteUserName = $("#user_name_" + siteStr).val();
        var sitePassword = $("#passwd_" + siteStr).val();
        var activeBtn = $(this);
        var data = frm.serialize();
        activeBtn.button('loading');
        data += "&userName=" + encodeURIComponent(siteUserName);
        data += "&passwd=" + encodeURIComponent(sitePassword);
        data += "&isConnectionTested=" + testSiteConnection;
        data += "&accCount=" + accCount;
        data += "&isSameMapAcc=" + isSameMapAcc;
        $.ajax({
            type: 'POST',
            url: 'SubmitNewSite.htm',
            data: data,
            dataType: 'json',
            success: function (response) {
                var url = '';
                if (response.success) {
                    url = pageParams.CONTEXT_ROOT + "/desk/CreateSite.htm";
                }
                var obj = {
                    response: response.msg,
                    success: response.success,
                    url: url
                };
                var dataVal = self.cache.siteType.val();
                if ((dataVal === 'googleAnalytics' || dataVal === 'ezAnalytics') &&
                    response.success) {
                    performGAAuthorization();
                }
                else {
                    successErrorDialog(obj);
                }
            },
            error: function (response) {
                var obj = {
                    response: response,
                    success: false,
                    url: ''
                };
                successErrorDialog(obj);
            }
        }).always(function () {
            activeBtn.button('reset');
        });
    }
    var integrationObj = {
        init: function () {
            self = this;
            pageParams = $.ezdia.config.pageParams;
            accBtnTemplate = $.ezdia.template.get('integration-account-btn');
            actiontype = 'create_site';
            ezdia.component.form.closeFormBtn('ez-js-form-right-close');
            this.cache = {
                editfrm: $('#ez-edit-store-form'),
                editfrmCol: $('#ez-edit-store-form-col'),
                editfrminputs: $('#ez-edit-store-form-inputs'),
                bulkEditFrm: $('#bulkEditFrm'),
                quickactionfield: $('#quickactionfield'),
                createfrm: $('#createNewSite'),
                siteType: $('[name=site_type]')
            };
        },
        load: function () {
            this.init();
            this.search();
            this.grid();
            $('#ez-test-site-config').on('click', this.testIntegration);
            $('#ez-test-semrush-config').on('click', this.testSemrushIntegration);
            $('#ez-google-authorize').on('click', this.googleAuthorize);
            $('#ez-edit-store-form-update').on('click', updateData);
            $('#ez-deactivate-site').on('click', confirmDeactivate);
            $('#ez-edit-store-form-cancel').on('click', function () {
                self.cache.editfrm.hide();
            });
            $('#ez-project-nav').scrollingNav();
            $.ezdia.storeForm.quickAction();
            pageLoadingDone();
            $.ezdia.stickyFormBtns({
                sticky: 'editForm-main',
                frm: 'ez-edit-store-form'
            });
        },
        grid: function (data) {
            var colModel = pageParams.colModel, colNames = pageParams.colNames, isGridMultiselect = pageParams.isGridMultiselect, _a = pageParams.rowNum, rowNum = _a === void 0 ? 10 : _a;
            pageParams.fetchFields = [];
            ezdia.component.grid.create({
                id: 'grid',
                datatype: 'local',
                caption: 'Integrations',
                data: data || [],
                colModel: colModel,
                colNames: colNames,
                rowNum: rowNum,
                multiselect: isGridMultiselect,
                beforeSelectRow: $.ezdia.desk.grid.beforeSelectRow,
                onSelectRow: self.onSelectRow,
                loadComplete: self.loadComplete,
                searchFrm: '#searchFrm',
                customeBtnsWrapId: 'ez-js-grid-actions-btns',
                hidegrid: false,
                gridview: true
            });
            this.setGridData();
        },
        setGridData: function () {
            var formType = pageParams.formType;
            $('#grid')
                .jqGrid('setGridParam', {
                url: 'siteData.htm',
                datatype: 'json',
                mtype: 'POST',
                jsonReader: {
                    records: 'records',
                    root: 'data',
                    total: 'total',
                    page: 'page'
                },
                postData: {
                    formtype: function () {
                        return formType;
                    },
                    searchCondition: function () {
                        return $('#searchFrm').search('getQueryString');
                    }
                }
            })
                .trigger('reloadGrid', [{ current: true }]);
        },
        onSelectRow: function (ids, clicked) {
            var grid = $(this);
            var selIds = getGridSelRow();
            var rowData = null;
            var deselectrow = grid.jqGrid('getGridParam', 'deselectrow');
            if ((selIds && selIds.length > 1) || deselectrow) {
                hideShowDeskForm('#bulkEditFrm');
                ezdia.component.form.show();
                if (deselectrow) {
                    grid.jqGrid('resetSelection');
                    grid.jqGrid('setGridParam', { deselectrow: false });
                    ezdia.component.form.hide();
                }
            }
            else if (ids && clicked) {
                ezdia.component.form.show();
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                accountKey = pageParams.formType + ids;
                rowData = $('#grid').jqGrid('getRowData', ids);
                $.ezdia.storeForm.resetSelectedRow.call(self);
                $.ezdia.storeForm.form.call(self, ids, true);
                setSiteType.call(self, true, rowData.site_type);
                setSiteName.call(self, rowData.site_name);
                setAdditionalFields(rowData);
                removeFields.call(self);
                self.getSiteFieldMap(ids);
                $.ezdia.storeForm.createWidgets.call(self);
                var tempSite = $('[name=site_type]').val();
                $('#ez-test-semrush-config').hide();
                if (tempSite === 'semrush') {
                    $('#ez-test-semrush-config').show();
                    $('#ez-test-site-config').hide();
                    $('#ez-google-authorize').hide();
                    $('#ez-form-create_site-site_url-row').show();
                }
                else if (tempSite === 'wordpress' || tempSite === 'aem') {
                    $('#ez-test-site-config').show();
                    $('#ez-google-authorize').hide();
                    $('#ez-form-create_site-site_url-row').show();
                }
                else if (tempSite === 'googleAnalytics' ||
                    tempSite === 'ezAnalytics') {
                    $('#ez-test-site-config').hide();
                    $('#ez-google-authorize').show();
                    $('#site_acc_mapping_checkbox-main').hide();
                    $('#ez-form-create_site-download_data-row').show();
                    $('#ez-form-create_site-breadcrumb-row').show();
                    $('#ez-form-create_site-pageidentification-row').show();
                }
                else {
                    $('#ez-test-site-config').hide();
                    $('#ez-google-authorize').hide();
                    $('#site_acc_mapping_checkbox-main').hide();
                    $('#ez-form-create_site-site_url-row').hide();
                }
            }
            else if (!selIds.length) {
                hideShowDeskForm('');
                ezdia.component.form.hide();
            }
            $.ezdia.desk.grid.toggleQuickLinks.call(this, selIds, clicked);
        },
        loadComplete: function () {
            // tslint:disable-next-line: no-shadowed-variable
            pageParams = $.ezdia.config.pageParams;
            var $grid = $('#grid');
            var recordCount = $grid.jqGrid('getGridParam', 'records');
            var rowNum = $grid.jqGrid('getGridParam', 'rowNum');
            var gridCaption = pageParams.gridCaption || 'Integrations';
            if (pageParams.isGridMultiselect && recordCount > rowNum) {
                gridCaption = ezdia.templates.grid.countAndSelectCaption(recordCount);
            }
            gridCaption = ezdia.templates.grid.caption(gridCaption);
            $grid.jqGrid('setCaption', gridCaption);
            hideShowDeskForm('#bulkEditFrm');
            ezdia.component.form.hide();
            setGridCellTitle();
            if (pageParams.sysSelectFirst) {
                $.ezdia.grid.selectFirstItem('#grid');
            }
        },
        getSiteFieldMap: function (ids) {
            var rowData = $('#grid').jqGrid('getRowData', ids);
            var response = pageParams.jqGridRowsData.data;
            var rowSiteName = rowData.site_name;
            var rowSiteType = rowData.site_type;
            var rowSiteData = {};
            var fieldMapObj = {};
            // eslint-disable-next-line consistent-return
            $.each(pageParams.siteTypes, function (key, value) {
                if (key.toLowerCase() === rowSiteType.toLowerCase()) {
                    rowSiteData = {
                        rowSiteType: key,
                        rowFieldMap: value.fields,
                        rowLabel: value.label
                    };
                    return false;
                }
            });
            $.each(response, function (i, obj) {
                if (obj.site_name === rowSiteName &&
                    obj.site_type === rowSiteData.rowSiteType) {
                    var toolName_1 = [];
                    var fieldMap_1 = [];
                    $.each(obj.siteAccMap, function (key, value) {
                        toolName_1.push(value.tool_name);
                        fieldMap_1.push(value.field_map);
                    });
                    fieldMapObj = {
                        toolName: toolName_1,
                        fieldMap: fieldMap_1,
                        aemComp: obj.aem_components
                    };
                }
            });
            return createEditSiteFieldMap(rowSiteData, fieldMapObj);
        },
        create: function () {
            this.init();
            $('#ez-project-nav').scrollingNav();
            $.ezdia.groupFormField.jspGroup('#ez-content');
            removeFields.call(this);
            this.cache.createfrm.show();
            setSiteType.call(this);
            $('[name=site_type]').on('change', siteTypeChange);
            $('#ez-save-data-btn').on('click', saveData);
            $('[name=site_acc_mapping_checkbox]').on('click', siteCheckBoxClicked);
            $('#ez-test-site-config').on('click', this.testIntegration);
            $('#ez-google-authorize').on('click', this.googleAuthorize);
            $('#ez-test-semrush-config').on('click', this.testSemrushIntegration);
            // $.ezdia.validate.create(pageParams.required, 'createNewSite');
            $.ezdia.validate.all(pageParams.colModel, 'createNewSite');
            $.ezdia.widgets.renderAll(pageParams.colModel, actiontype);
            $('#ez-test-site-config,#ez-test-semrush-config,#ez-google-authorize, #site_acc_mapping_checkbox-main, #site_url-main').hide();
            $('#createNewSite').show();
            pageLoadingDone();
        },
        testIntegration: function (old) {
            testConfig.call(this, old);
        },
        testSemrushIntegration: function () {
            testSemrushConfig.call(this);
        },
        googleAuthorize: function () {
            performGAAuthorization.call(this);
        },
        valiadtePubSite: function (elem, value) {
            if ($.inArray('wordpress', value) === 1 &&
                ezj.wpRoleAuthorized === 'false') {
                elem.multiSelect('deselect', value);
                $('#statusMsg')
                    .html('Missing credentials or unsufficient roles!!!')
                    .dialog({
                    modal: true,
                    title: 'Unauthorized User',
                    buttons: {
                        Ok: function () {
                            $(this).dialog('close');
                        }
                    }
                });
            }
        },
        search: function () {
            var searchFields = $.ezdia.getJsonObject(pageParams.searchFieldsJson) || [];
            var searchFieldsJson = {};
            $.each(searchFields, function (i, column) {
                searchFieldsJson[column.name] = column;
            });
            pageParams.searchFieldsJson = searchFieldsJson;
            $.ezdia.initGenericSearch('#searchFrm');
        }
    };
    var pages;
    (function (pages) {
        pages.integration = integrationObj;
    })(pages = ezdia.pages || (ezdia.pages = {}));
    /*
     ** This $.ezdia is just for old code support
     ** DON'T USE THIS
     */
    $.ezdia.integration = integrationObj;
})(ezdia || (ezdia = {}));
/**
 * Custome validate method for create site url field
 */
$.validator.addMethod('siteUrlValidation', function siteUrlValidation(value, element) {
    var val = $('[name="site_type"]').val();
    if (val === 'googleAnalytics' || val === 'ezAnalytics') {
        return $.validator.methods.url.call(this, value, element);
    }
    return true;
}, 'Please enter valid url.');
